import { createContext } from 'react';

const recursoContext = createContext();

export default recursoContext;
